// lib/datetime.ts — shared date-picker guards for any form recording a
// subscription/redemption/dealing event. A subscription/redemption records
// money that has ALREADY moved, never a future promise (mirrors the
// server's own _reject_future_as_of / _reject_before_fund_inception in
// api/apps/portfolio/views.py — this is the client-side mirror so the
// operator sees an inline warning instead of a post-submit 400).

/** `max` value for a `<input type="datetime-local">` — clamps the picker to
 * "now" in the browser's local time. */
export const nowLocalForDatetimeMax = () => {
  const d = new Date();
  d.setSeconds(0, 0);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
};

/** `max` support for the TIME portion of `datetime-local` is inconsistent
 * across browsers — some clamp the date but still let the hour/minute
 * spinner scroll past "now". Check explicitly on every change instead of
 * relying on the picker to enforce it. */
export const isFutureWhen = (when: string) =>
  !!when && new Date(when).getTime() > Date.now();

/** A new subscription can't predate the fund's current earliest investor —
 * see _reject_before_fund_inception on the server for the full reasoning
 * (backdating ahead of the earliest investor would hand out the one-time
 * "first investor" seed price to a second person). */
export const isBeforeInception = (when: string, earliestSubAt: string | null) =>
  !!when && !!earliestSubAt && new Date(when).getTime() < new Date(earliestSubAt).getTime();
